import React, { useState } from 'react';
import { observer } from 'src/utils/mobx-react';
import { useAppStateContext } from 'src/AppState/AppState';
import { PromotedEventsList } from './promotedEventsList/PromotedEventsList';
import {
    ColumnOneOfTwo,
    MainContent,
    TwoColumnResponsiveContentReverse,
} from 'src/domains/layouts/shared/layout/Layout.style';
import { ListHeader } from 'src/domains/layouts/shared/cms/list/listHeader/ListHeader';
import { Loader } from 'src/domains/layouts/shared/loader/Loader';
import { ListWrapper } from 'src/domains/layouts/shared/cms/list/List.style';
import { Button } from 'src/domains/common/components/button/button';
import { BulkDeleteDialog } from 'src/main/cms/PromotedEvents/bulkDeleteDialog/bulkDeleteDialog';
import { BulkDeleteDialogState } from 'src/main/cms/PromotedEvents/bulkDeleteDialog/bulkDeleteDialogState';
import { DialogGeneric } from 'src/domains/common/components/dialog/DialogGeneric';
import { PromotedEventForm } from './promotedEventsForm/PromotedEventsForm';

export const PromotedEvents = observer('PromotedSports', () => {
    const {
        cmsState: { promotedEventsState },
        trpcClient,
        sdkStaff,
    } = useAppStateContext();
    const { starEventsLabel, topEvents } = useAppStateContext().configState.config;
    const isLoading = promotedEventsState.isPromotedEventsDataLoading;
    const [bulkDeleteDialogState] = useState(
        () =>
            new BulkDeleteDialogState(
                sdkStaff.models,
                trpcClient.client.promotedEvents.bulkDeletePromotedEvents.mutate,
                promotedEventsState.promotedEventsResource
            )
    );

    return (
        <MainContent>
            <TwoColumnResponsiveContentReverse>
                <ColumnOneOfTwo>
                    <ListWrapper>
                        <ListHeader label='Promoted Events'>
                            <>
                                {topEvents === true
                                    ? 'Events will appear in dedicated page.'
                                    : `Events will appear on the homepage under the <b>${starEventsLabel}</b> section.`}{' '}
                                The order of the events is how it appears on the live site. You can change the order
                                using the drag icon below.
                                <b> For horse and greyhound racing, only outrights and antepost events can be added.</b>
                            </>
                        </ListHeader>
                        {isLoading || promotedEventsState.promotedEventsData === null ? (
                            <Loader isActive={isLoading} />
                        ) : (
                            <>
                                <Button
                                    onClick={bulkDeleteDialogState.openDialog}
                                    variant='destructive'
                                    icon='trash'
                                    className='mb-4'
                                >
                                    Bulk Delete
                                </Button>
                                <PromotedEventsList />
                            </>
                        )}
                    </ListWrapper>
                </ColumnOneOfTwo>

                <ColumnOneOfTwo>
                    <PromotedEventForm
                        onCreate={async () => await promotedEventsState.promotedEventsResource.refresh()}
                    />
                </ColumnOneOfTwo>
            </TwoColumnResponsiveContentReverse>
            {bulkDeleteDialogState.isOpen === true && <BulkDeleteDialog state={bulkDeleteDialogState} />}
            {bulkDeleteDialogState.isSuccessDialogOpen && (
                <DialogGeneric
                    title='Success'
                    message={<p>Successfully deleted selected events.</p>}
                    onConfirm={bulkDeleteDialogState.hideSuccessDialog}
                    confirm_label='Continue'
                />
            )}
            {bulkDeleteDialogState.isErrorDialogOpen && (
                <DialogGeneric
                    title='Error'
                    message={<p>Could not delete selected events. Please try again.</p>}
                    onConfirm={bulkDeleteDialogState.hideErrorDialog}
                    confirm_label='Continue'
                />
            )}
        </MainContent>
    );
});
